import logo from '../../../assets/images/Logo.svg';

interface TitleInterface {
  visualizationKind: 'sendCode' | 'changePassword'
}

export default function Title({ visualizationKind }: TitleInterface) {
  return (
    <div className="loginTitle">
      <div className="labelTitle">
        <div>
                Alteração de senha
        </div>
        {visualizationKind === 'sendCode' && (
          <div className="subtitle">
                  Informe seu CPF de acesso para alterar sua senha
          </div>
        )}

        {visualizationKind === 'changePassword' && (
          <div className="subtitle">
                  Crie uma senha e informe o código enviado ao seu e-mail
          </div>
        )}
      </div>
      <img src={logo} alt="logo" className="logo" />
    </div>
  );
}
